module.exports = __webpack_public_path__ + "static/img/新媒体实验室首图.6eaee1bb.png";